import PropTypes from 'prop-types';
import { fileActions } from 'core/File';
import { useTranslation } from 'react-i18next';
import {
    Container,
    Image,
    ImageContainer
} from './styled';
import {
    ExpandButton,
    Loader,
    Modal
} from 'mol-ui';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const FileModal = ({
    active = false,
    file: {
        folder_id,
        id,
        name,
        url
    } = {},
    onClose
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        status
    } = useSelector('file');

    useEffect(() => {
        if (active && !url) {
            const data = {
                file_id: id,
                folder_id
            };
            dispatch(fileActions.getFile(data));
        }
    }, [active, url]);

    const modalProps = {
        active,
        onToggle: onClose
    };

    return (
        <Modal { ...modalProps }>
            <Container>
                <Loader
                    active={ status === `file-loading-${ id }` }
                    size={ 35 }
                    type="dots"
                />
                {
                    !!url &&
                    <ImageContainer>
                        <Image alt={ name } loading="lazy" src={ url } />
                    </ImageContainer>
                }
                <ExpandButton
                    caption={ t('Volver') }
                    size={ 100 }
                    onClick={ onClose }
                />
            </Container>
        </Modal>
    );
};

FileModal.propTypes = {
    active: PropTypes.bool,
    file: PropTypes.object,
    onClose: PropTypes.func
};

export default FileModal;
